import { Link } from "react-router-dom";
import { ArrowRight, MapPin, Star } from "lucide-react";
import { rm } from "@/lib/api";

const IMG = "https://images.unsplash.com/photo-1574629810360-7efbbe195018?w=900&q=70";

export const CentreCard = ({ c, row = false }) => (
  <Link to={`/sport-centres/${c.slug}`} data-testid={`centre-card-${c.slug}`} className={`asv-card asv-lift group overflow-hidden ${row ? "flex sm:block" : "block"}`}>
    <div className={`relative overflow-hidden ${row ? "min-h-[132px] w-[38%] shrink-0 sm:aspect-[4/3] sm:w-auto" : "aspect-[4/3]"}`}>
      <img src={c.image || IMG} alt={c.name} className={`${row ? "absolute inset-0" : ""} h-full w-full object-cover transition-transform duration-500 group-hover:scale-105`} />
    </div>
    <div className={row ? "min-w-0 flex-1 p-3 sm:p-4" : "p-4"}>
      <p className="line-clamp-1 text-xs font-semibold uppercase tracking-wide asv-accent">{c.sports.join(", ")}</p>
      <p className="asv-display mt-1 line-clamp-2 text-lg font-bold leading-tight">{c.name}</p>
      <p className="asv-muted mt-1 flex items-start gap-1 text-xs"><MapPin className="mt-0.5 h-3.5 w-3.5 shrink-0" /><span className="line-clamp-1">{c.state || c.address}</span></p>
      <div className="mt-3 flex items-center justify-between gap-2 text-xs">
        <span className="asv-muted">{c.venues} venue{c.venues === 1 ? "" : "s"}{c.events ? ` · ${c.events} event${c.events === 1 ? "" : "s"}` : ""}
          {!!c.rating_count && <span className="ml-1 inline-flex items-center gap-0.5 font-bold"><Star className="h-3 w-3 fill-current asv-accent" />{c.rating.toFixed(1)}</span>}</span>
        {c.price_from_sen ? <span className="font-bold">from {rm(c.price_from_sen)}</span> : <span className="inline-flex items-center gap-1 font-semibold">See more <ArrowRight className="h-3.5 w-3.5" /></span>}
      </div>
    </div>
  </Link>
);
